import React, { useContext } from "react";
import { Info } from "lucide-react";
import AppContext from "../../context/AppContext";
import CommonButton from "../common/CommonButton";
import translations from "../common/Translations";

const DeleteTask = ({ isLoading, onClose, deleteFunction, onDeleteText,comment,setComment, scopeMessage, confirmTooltip }) => {
    const { theme,langMode } = useContext(AppContext);
    return (
        <div className="fixed inset-0 flex justify-center items-center bg-black bg-opacity-50 z-50">
            <div
                data-tooltip-bounds
                className={`bg-white rounded-lg p-6 relative w-[550px] max-w-[calc(100vw-2rem)] shadow-lg ${theme === "dark"
                        ? "dark-mode border border-red-500"
                        : theme === "high-contrast"
                            ? "high-contrast"
                            : ""
                    }`}
            >
             
                <div className=" flex flex-col justify-center items-center ">
                    <h2 className="text-xl text-center flex items-center mb-2 font-semibold text-gray-800">{translations[langMode].deleteTaskTitle}</h2>
                    <p className="text-sm text-center text-gray-700 mb-2">
                      {translations[langMode].areusure}
                    </p>
                    {scopeMessage && (
                      <div className="flex w-full items-start gap-1 rounded-lg border border-amber-200 bg-amber-50 px-3 py-2 dark:border-amber-900/50 dark:bg-amber-950/30">
                        <Info className="mt-0.5 h-4 w-4 shrink-0 text-amber-500 dark:text-amber-400" />
                        <p className="text-xs leading-5 text-amber-800 dark:text-amber-300">
                          <span className="font-semibold">{translations[langMode].noteLabel}</span>{" "}
                          {scopeMessage}
                        </p>
                      </div>
                    )}
                    <input required value={comment} onChange={(e)=>setComment(e.target.value)} type="text" className="mt-4 h-24 w-full bg-gray-100 rounded-lg border border-gray-300" />
                </div>
                <div className="flex justify-center gap-3 pt-4 border-t border-gray-200">
                    <CommonButton
                        onClick={onClose}
                        variant="outline"
                        tooltipText={translations[langMode].cancelandclose}
                        tooltipPosition="top"
                        tooltipClassName="max-w-[10rem]"
                        className="rounded-md font-medium"
                    >
                        {translations[langMode].cancel}
                    </CommonButton>
                    <CommonButton colorIntent="danger"
                        type="submit"
                        variant="danger"
                        tooltipText={confirmTooltip ?? translations[langMode].proceedwithdeleaction}
                        tooltipPosition="top"
                        tooltipClassName="max-w-[10rem]"
                        className={`rounded-md font-medium ${isLoading ? "opacity-60" : ""}`}
                        onClick={deleteFunction}
                        disabled={isLoading}
                    >
                        {isLoading ?  translations[langMode].Processing : translations[langMode].delete}
                    </CommonButton>
                </div>
            </div>
        </div>
    );
};

export default DeleteTask;
